import moment from "moment";
import React from 'react'
const json = {
    register_date: moment(new Date()).format("DD-MM-YYYY"),
    hr: '',
    pr: '',
    rr : '',
    bp: '',
    bt: '',
    other: '',
    height: '',
    weight: '',
    search:'',
    id:'',
    patient_id : '',
    sat : '',
    visit_id : ''
}

export default json;
